import { RavelElement } from '../../../base/ravel-element/src/RavelElement.js';
import globalStyles from '../../../../common/global-styles.js';
import { RavelEmoji } from '../../../../../modules/RavelEmoji.js';
import { ravelComponentPath } from '../../../../common/RavelComponentPath.js';

export class RavelPot extends RavelElement {
    static get localStyles() {
        return `
        <style>
        #container {
            position: absolute;
            cursor: pointer;
            user-select: none;
        }
        #pot-marker, #pot-knob {
            position: relative;
        }
        #sensor {
            position: absolute;
            left: -10%;
            top: -10%;
            width: 120%;
            height: 120%;
            border-radius: 50%;
            
        }
        </style>
        `;
    }
  
    static get html() { 
        return `
        <div id="container">
        <div id="sensor"></div>
        <div id="pot-knob"></div>
        <div id="pot-marker"></div>
        </div>
        `;
    }
 
    static get observedAttributes() { 
        return [...super.baseObservedAttributes, 
            'size', 'w', 'h', 'use-svg', 'color',
            'marker', 'icon', 'marker', 'angle', 'min', 'max',
            'value', 'signals', 'signal-out'];
    }

    constructor() {
        super();
        const template = document.createElement('template');
        template.innerHTML = globalStyles
            + this.constructor.localStyles
            + this.constructor.html;
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.appendChild(template.content.cloneNode(true));
        this.initialize();
    }
  
    connectedCallback() {
        this.setup();
    }
    
    disconnectedCallback() {
        this.teardown();
    }
    
    initialize() {
        this.container = this.shadowRoot.querySelector('#container');
        this.potMarker = this.shadowRoot.querySelector('#pot-marker');
        this.potKnob = this.shadowRoot.querySelector('#pot-knob');
        this.sensor = this.shadowRoot.querySelector('#sensor');
        this.marker = '';
        this.icon = 'white-circle';
        this.size = 24;
        this.signals = [];
        this.value = 0;
        this.noClick = false;
        this.showFeedback = false;
        this.x = 0;
        this.y = 0;
        this.width = 50;
        this.height = 50;
        this.min = 0;
        this.max = 1;
        this.offsetX = 0;
        this.offsetY = 0;
        this.angle = 0;
        this.useSvg = false;
    }
  
    setup = () => {
        this.observedMessages = [`${this.id}`];
        this.subscribe(this.observedMessages);
        this.subscribe(this.signals);  
        //this.potKnob.textContent = RavelEmoji.getRandomRoundEmoji();
        //this.potMarker .textContent = RavelEmoji['white-circle']; // 
        // x, y are the center point

        this.container.style.top = `${this.y}px`;
        this.container.style.left = `${this.x}px`;
        this.container.style['width'] = `${this.width}px`;
        this.container.style['height'] = `${this.height}px`;
        this.container.style['font-size'] = `${this.width}px`;
        this.container.style['font-size'] = `${this.width}px`;
        this.potKnob.textContent = RavelEmoji[this.icon];
        this.potMarker.textContent = RavelEmoji[this.marker]; // 
        this.potMarker.style['font-size'] = `${this.width / 5}px`;
        this.potMarker.style['top'] = `-${this.width - this.width / 16}px`;
        this.potMarker.style['left'] = `${- this.width /  4 }px`;
        this.potKnob.style['line-height'] = `-${this.width + 10}px`;
        this.setFromValue();
        if (this.useSvg) {
            this.shadowRoot.querySelector('#pot-knob').innerHTML = this.potSvg;
            this.shadowRoot.querySelector('#pot-knob-svg').style.width = `${this.width}px`;
            this.shadowRoot.querySelector('#pot-knob-svg').style.height = `${this.height}px`;
            this.shadowRoot.querySelector('#pot-knob-svg').querySelector('#circle').style.fill = `${this.color}`;
        }
        //this.potKnob.style['top'] = `-${this.size / 8}px`;
        this.potMarker.style['opacity'] = `0.75`;
        const rect = this.container.getBoundingClientRect();
        this.centerX = rect.left + rect.width / 2;
        this.centerY = rect.top + rect.height / 2;
        if (!this.noClick) {
            this.addEventListener('pointerdown', this.handleClick);
        }
        this.addEventListener(`${this.id}`, this.handleEvent);
        this.broadcastMessage('register-sensor', this.id, this.container);
        //this.broadcastMessage('register-sensor', this.id, { x: this.x + this.w/2, y: this.y + this.h/2, w: this.w, h: this.height });
    }

    handleClick = (e) => {
        e.preventDefault();
        // Update center values dynamically in case layout shifted
        const rect = this.container.getBoundingClientRect();
        this.centerX = rect.left + rect.width / 2;
        this.centerY = rect.top + rect.height / 2;
        this.calculatePotAngle(e.clientX, e.clientY);
        document.addEventListener('pointermove', this.dragElement);
        document.addEventListener('pointerup', this.endDragElement);
        document.addEventListener('pointerleave', this.endDragElement);
    }

    dragElement = (e) => {
        e.preventDefault();
        this.calculatePotAngle(e.clientX + this.offsetX, e.clientY + this.offsetY);
    }

    endDragElement = () => {
        document.removeEventListener('pointermove', this.dragElement);
        document.removeEventListener('pointerup', this.endDragElement);
        document.removeEventListener('pointerleave', this.endDragElement);
    }

    handleEvent = (e) => {
        e.preventDefault();
        const type = e.detail.cmd;
        console.log(type);
        if (type === 'select') {
            this.sensor.style.backgroundColor = 'rgba(255, 255, 0, 0.5)';
        }
        if (type === 'unselect') {
            this.sensor.style.backgroundColor = 'rgba(255, 255, 255, 0)';
        }
        if (type === 'virtual-click') {
            let x = e.detail.content.startX;
            let y = e.detail.content.startY;
            this.offsetX = Number(e.detail.content.offsetX);
            this.offsetY = Number(e.detail.content.offsetY);
            const rect = this.container.getBoundingClientRect();
            this.centerX = (rect.left + rect.width / 2);
            this.centerY = (rect.top + rect.height / 2);
            this.calculatePotAngle(x + this.offsetX, y + this.offsetY);
            document.addEventListener('pointermove', this.dragElement);
            document.addEventListener('pointerup', this.endDragElement);
            document.addEventListener('pointerleave', this.endDragElement);
            console.log(this.offsetX + " " + this.offsetY);
        }
        if (type === 'virtual-drag') {
            this.calculatePotAngle(e.clientX, e.clientY);
        }
        if (type === 'virtual-release') {
            this.offsetX = 0;
            this.offsetY = 0;
            document.removeEventListener('pointermove', this.dragElement);
            document.removeEventListener('pointerup', this.endDragElement);
            document.removeEventListener('pointerleave', this.endDragElement);
        }
    }

    
    teardown = () => {
        this.unsubscribe(this.signals);
        this.broadcastMessage('register-sensor', this.id);
        if (!this.noClick) {
            this.removeEventListener('pointerdown', this.handleClick);
        }
        this.removeEventListener(`${this.id}`, this.handleEvent);
    }
    
    calculatePotAngle = (x, y) => {
    	let d1 = y - this.centerY;
    	let d2 = x - this.centerX;
    	let r = Math.sqrt(Math.pow(d1, 2) + Math.pow(d2, 2));
    	let a = -Math.asin(d1 / r);
        if (x > this.centerX)  {
            a = 3.14 - a;
        }
        if ((x < this.centerX) && (y > this.centerY))  {
            a = 6.28 + a;
        }
    	//console.log("Angle " + (a * 57.296));
    	a = (a * 57.296);
        // TODO: add a check for pinned High or Low
        if (!((a > 210) && (a < 300))) {
            this.angle = a;
            this.container.style["transform"] = "rotate(" + this.angle + "deg)";
        }
       // console.log(this.angle);
        if (this.angle <= 210) {
            this.value = this.map(this.angle, 0, 210, 0.3, 1);
        } else {
            this.value = this.map(this.angle, 305, 360, 0, .3);
        }
        this.sendMessage(this.signalOut, this.id, this.value);
        //console.log(`send: ${this.signalOut} ${(this.value)}`);
    }

    setFromValue = () => {
        console.log(this.value + ' ' + this.angle);
        if (this.value <= 0.3) {
            this.angle = this.map(this.value, 0, 0.3, 305, 360);
        } else {
            this.angle = this.map(this.value, 0.3, 1.0, 0, 210);
        }
        console.log(this.angle);
        this.container.style["transform"] = "rotate(" + this.angle + "deg)";
    }
    
    attributeChangedCallback(name, oldValue, newValue) {
        // Call the parent's attributeChangedCallback to preserve its behavior
        super.attributeChangedCallback(name, oldValue, newValue);
        if (name === 'size') {
            this.size = Number(newValue);
        }
        if (name === 'x') {
            this.container.style.position = 'absolute';
            this.x = Number(newValue);
        }
        if (name === 'y') {
            this.container.style.position = 'absolute';
            this.y = Number(newValue);
        }
        if (name === 'use-svg') {
            this.useSvg = true;
        }
        if (name === 'w') {
            this.width = Number(newValue);
        }
        if (name === 'h') {
            this.height = Number(newValue);
        }
        if (name === 'color') {
            this.color = newValue;
        }
        if (name === 'orientation') {
            this.orientation = newValue;
        }
        if (name === 'icon') {
            this.icon = newValue;
        }
        if (name === 'marker') {
            this.marker = newValue;
        }
        if (name === 'angle') {
            this.angle = Number(newValue);
        }
        if (name === 'value') {
            this.value = Number(newValue);
        }
        if (name === 'signals') {
            this.signals = newValue.split(',');
        }
        if (name === 'signal-out') {
            this.signalOut = newValue;
        }
        if (name === 'no-click') {
            this.noClick = true;
        }
        if (name === 'show-feedback') {
            this.showFeedback = true;
        }
    }

    map = (val, in_min, in_max, out_min, out_max) => {
        return (val - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
    }

    potSvg = `
    <?xml version="1.0" encoding="UTF-8" standalone="no"?>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="pot-knob-svg"
   width="267.03113"
   height="257.45898"
   viewBox="0 0 267.03113 257.45898"
   sodipodi:docname="pot-1.svg"
   inkscape:version="1.3.2 (091e20e, 2023-11-25)"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg">
  <defs
     id="defs1" />
  <sodipodi:namedview
     id="namedview1"
     pagecolor="#ffffff"
     bordercolor="#666666"
     borderopacity="1.0"
     inkscape:showpageshadow="2"
     inkscape:pageopacity="0.0"
     inkscape:pagecheckerboard="0"
     inkscape:deskcolor="#d1d1d1"
     inkscape:zoom="4.9166667"
     inkscape:cx="45.050847"
     inkscape:cy="124.67797"
     inkscape:window-width="1336"
     inkscape:window-height="841"
     inkscape:window-x="0"
     inkscape:window-y="38"
     inkscape:window-maximized="0"
     inkscape:current-layer="g1"
     showguides="false" />
  <g
     inkscape:groupmode="layer"
     inkscape:label="Image"
     id="g1"
     transform="translate(-1052.7501,459.03516)">
    <path
       id="rect70"
       style="fill:#000000;fill-opacity:0.5;stroke:none;stroke-width:1.64482"
       d="M 1146.9317 -459.03516 L 1146.9317 -417.36914 L 1107.1778 -417.36914 L 1107.1778 -374.47071 L 1061.379 -374.47071 L 1061.379 -286.45313 L 1062.3224 -286.45313 L 1062.3224 -286.18555 L 1107.1778 -286.18555 L 1107.1778 -243.24219 L 1146.9317 -243.24219 L 1146.9317 -201.57618 L 1235.17 -201.57618 L 1235.17 -243.24219 L 1274.9239 -243.24219 L 1274.9239 -286.18555 L 1319.7813 -286.18555 L 1319.7813 -374.42383 L 1274.9239 -374.42383 L 1274.9239 -417.36914 L 1235.17 -417.36914 L 1235.17 -459.03516 L 1146.9317 -459.03516 z " />
    <path
       id="circle"
       style="fill:#e3b505;fill-opacity:1;stroke:none;stroke-width:1.33333"
       d="m 1191.0508,-411.66211 a 81.355934,81.355934 0 0 0 -78.5508,60.6875 h 38.9844 v 41.33789 H 1112.5 a 81.355934,81.355934 0 0 0 78.5508,60.6875 81.355934,81.355934 0 0 0 81.3554,-81.35547 81.355934,81.355934 0 0 0 -81.3554,-81.35742 z" />
    <rect
       style="fill:#000000;fill-opacity:1;stroke:none;stroke-width:1.58756"
       id="rect72"
       width="90.982903"
       height="41.254181"
       x="1061.0891"
       y="-351.0853" />
  </g>
</svg>
`;
}
